import script from "./InitiativeContentForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./InitiativeContentForm.vue?vue&type=script&lang=ts&setup=true"

import "./InitiativeContentForm.vue?vue&type=style&index=0&id=11dd1457&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11dd1457"]])

export default __exports__